import { attachmentTypes, relatedResourceTypes } from './attachment-types';
import { countryCodes } from './country-codes';
import { zipCodeMasks } from './zip-code-masks';

export * from './record-states';
export * from './content-feeds';
export * from './content-categories';
export * from './entity-history';
export * from './poi';
export * from './recurring-settings';
export * from './notifications';
export * from './posthog-types';
export * from './analytics-insights-types';
export * from './member-world-groups';
export * from './voting-types';
export * from './raffle';

export const AttachmentTypes = attachmentTypes;
export const CountryCodes = countryCodes;
export const ZipCodeMasks = zipCodeMasks;

export {
  relatedResourceTypes,
};

export type RelatedResourceType = typeof relatedResourceTypes[number];

export const PartnerOfferValidityTypes = ['day', 'week', 'month'] as const;
export const MetricTypes = ['views'] as const;
export const MetricResourceTypes = ['event', 'partner', 'venue', 'partner_offer', 'estate', 'content_feed_record', 'organizer'] as const;

export const EVENT_PRICE_TYPES = [
  'freeOfCharge',
  'withCosts',
  'donation',
  'unknown',
] as const;

export type EventPriceType = typeof EVENT_PRICE_TYPES[number];

export const EVENT_PRICE_TYPE = {
  FREE_OF_CHARGE: 'freeOfCharge',
  WITH_COSTS: 'withCosts',
  DONATION: 'donation',
  UNKNOWN: 'unknown',
} as const;
